export const ACCOUNT_ID_CONFIG = 'ACCOUNT_ID_CONFIG';
export const ACCOUNT_ID_CONFIG_UPDATE_ERROR = 'ACCOUNT_ID_CONFIG_UPDATE_ERROR';

export const STATIC_ACCOUNT_ID = 'static';
export const DYNAMIC_ACCOUNT_ID = 'dynamic';
export const SECOND_ACCOUNT_ID = 'second_account_id';
export const AUTO_GENERATE_ACCOUNT_ID = 'auto_generate';
export const OPTIONAL_SECOND_ACCOUNT_ID = 'optional_second_account_id_for_dynamic_warehouse_mapping';

export const DIRECT_DIVISION_CODE_MAPPING = 'direct_division_code_mapping';
export const CUSTOM_DIVISION_CODE_MAPPING = 'custom_division_code_mapping';

export const STATIC_ACCOUNT_ID_TYPES = [STATIC_ACCOUNT_ID, SECOND_ACCOUNT_ID, OPTIONAL_SECOND_ACCOUNT_ID];
export const SECOND_ACCOUNT_ID_TYPES = [SECOND_ACCOUNT_ID, OPTIONAL_SECOND_ACCOUNT_ID];

export const ACCOUNT_ID_IDENTIFIER = {
  WAREHOUSE: 'warehouse',
  SHIP_TO_COUNTRY: 'ship-to-country',
};
